import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LegalPage = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      title: "Mentions Légales",
      lastUpdate: "Dernière mise à jour : Mars 2026",
      sections: [
        {
          title: "1. Éditeur du site",
          text: `Le site themetalove.com est édité par :

MetaLove
Email : contact@themetalove.com

Directrice de la publication : Rose E. Caldwell`
        },
        {
          title: "2. Hébergement",
          text: `Le site est hébergé par :

Netlify
https://www.netlify.com`
        },
        {
          title: "3. Propriété intellectuelle",
          text: `L'ensemble du contenu du site themetalove.com (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de MetaLove ou de ses partenaires, sauf mention contraire.

Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de MetaLove.

La série de romans "Et mon Cœur a reconnu le Tien" et tous les éléments associés sont protégés par le droit d'auteur.`
        },
        {
          title: "3 bis. Marque déposée",
          text: `MetaLove® est une marque déposée auprès de l'Institut National de la Propriété Industrielle (INPI).

MetaLove est une entité indépendante et n'est en aucun cas affiliée à, sponsorisée par, ou liée à Meta Platforms, Inc. (anciennement Facebook, Inc.) ou à toute autre entité portant le nom "Meta".

Toute confusion entre ces entités serait fortuite et non intentionnelle.`
        },
        {
          title: "4. Conditions d'utilisation",
          text: `En accédant au site themetalove.com, vous acceptez les présentes conditions d'utilisation.

L'utilisation du site implique l'acceptation pleine et entière des conditions générales d'utilisation décrites ci-dessous.

MetaLove se réserve le droit de modifier, à tout moment et sans préavis, le site et les services ainsi que les présentes CGU.`
        },
        {
          title: "5. Candidatures",
          text: `Le dépôt d'une candidature sur MetaLove est gratuit et sans engagement.

MetaLove se réserve le droit de refuser toute candidature sans avoir à justifier sa décision.

Les informations fournies dans le formulaire de candidature doivent être exactes et sincères. Toute fausse déclaration pourra entraîner le rejet de la candidature.`
        },
        {
          title: "6. Responsabilité",
          text: `MetaLove s'efforce de fournir des informations aussi précises que possible. Toutefois, MetaLove ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour.

MetaLove ne saurait être tenue pour responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site.

MetaLove n'est pas responsable des rencontres ou des relations qui pourraient naître suite à une mise en relation par ses services.`
        },
        {
          title: "7. Liens hypertextes",
          text: `Le site themetalove.com peut contenir des liens vers d'autres sites. MetaLove n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.`
        },
        {
          title: "8. Droit applicable",
          text: `Les présentes mentions légales sont soumises au droit français.

En cas de litige, et après échec de toute tentative de recherche d'une solution amiable, les tribunaux français seront seuls compétents.`
        },
        {
          title: "9. Contact",
          text: `Pour toute question concernant ces mentions légales :

Email : contact@themetalove.com`
        }
      ]
    },
    en: {
      title: "Legal Notice",
      lastUpdate: "Last updated: March 2026",
      sections: [
        {
          title: "1. Site Publisher",
          text: `The website themetalove.com is published by:

MetaLove
Email: contact@themetalove.com

Publication Director: Rose E. Caldwell`
        },
        {
          title: "2. Hosting",
          text: `The site is hosted by:

Netlify
https://www.netlify.com`
        },
        {
          title: "3. Intellectual Property",
          text: `All content on themetalove.com (texts, images, graphics, logos, icons, etc.) is the exclusive property of MetaLove or its partners, unless otherwise stated.

Any reproduction, representation, modification, publication, or adaptation of all or part of the site elements, by any means or process, is prohibited without prior written authorization from MetaLove.

The novel series "And My Heart Recognized Yours" and all associated elements are protected by copyright.`
        },
        {
          title: "3 bis. Registered Trademark",
          text: `MetaLove® is a trademark registered with the Institut National de la Propriété Industrielle (INPI), the French intellectual property office.

MetaLove is an independent entity and is in no way affiliated with, sponsored by, or connected to Meta Platforms, Inc. (formerly Facebook, Inc.) or any other entity bearing the name "Meta".

Any confusion between these entities would be coincidental and unintentional.`
        },
        {
          title: "4. Terms of Use",
          text: `By accessing themetalove.com, you agree to these terms of use.

Use of the site implies full and complete acceptance of the general terms of use described below.

MetaLove reserves the right to modify the site, services, and these terms at any time without notice.`
        },
        {
          title: "5. Applications",
          text: `Submitting an application to MetaLove is free and non-binding.

MetaLove reserves the right to reject any application without having to justify its decision.

Information provided in the application form must be accurate and sincere. Any false statement may result in rejection of the application.`
        },
        {
          title: "6. Liability",
          text: `MetaLove strives to provide information as accurate as possible. However, MetaLove cannot be held responsible for omissions, inaccuracies, or deficiencies in updates.

MetaLove cannot be held responsible for direct or indirect damages resulting from access to or use of the site.

MetaLove is not responsible for meetings or relationships that may arise from connections made through its services.`
        },
        {
          title: "7. Hyperlinks",
          text: `The themetalove.com website may contain links to other sites. MetaLove has no control over these sites and disclaims any responsibility for their content.`
        },
        {
          title: "8. Applicable Law",
          text: `These legal notices are subject to French law.

In case of dispute, and after failure of any attempt to find an amicable solution, French courts will have sole jurisdiction.`
        },
        {
          title: "9. Contact",
          text: `For any questions regarding these legal notices:

Email: contact@themetalove.com`
        }
      ]
    }
  };

  const c = content[language];

  return (
    <div 
      data-testid="legal-page"
      className="min-h-screen pt-24 pb-16"
      style={{ backgroundColor: '#050A14' }}
    >
      <div className="max-w-3xl mx-auto px-6">
        {/* Header */}
        <div className="mb-16 text-center">
          <h1 
            className="font-heading text-4xl md:text-5xl font-light mb-4"
            style={{ color: '#D1D5DB' }}
          >
            {c.title}
          </h1>
          <p style={{ color: '#6B7280' }} className="text-sm">
            {c.lastUpdate}
          </p>
          <div className="divider-silver w-20 mx-auto mt-8" />
        </div>

        {/* Content */}
        <div className="space-y-10">
          {c.sections.map((section, index) => (
            <div key={index}>
              <h2 
                className="font-heading text-xl md:text-2xl mb-4"
                style={{ color: '#D1D5DB' }}
              >
                {section.title}
              </h2>
              <div 
                className="font-body text-sm md:text-base leading-relaxed whitespace-pre-line text-justify"
                style={{ color: '#9CA3AF' }}
              >
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
